import React from "react";
import { Link } from "react-router-dom";

export default function SiteHeader({ minimal = false }) {
  return (
    <header
      data-testid="subpage-header"
      className="sticky top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-[#e2e8f0]"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <img
            src="/tradecure-logo.png"
            alt="Tradecure"
            className="h-8 w-8 object-contain"
            width="32"
            height="32"
          />
          <span className="font-heading text-xl font-extrabold tracking-tight">
            tradecure
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-semibold">
          <Link to="/knowledge-hub" data-testid="nav-knowledge" className="link-underline text-[#0f172a]/80 hover:text-[#084392]">
            Knowledge Hub
          </Link>
          <Link to="/blog" data-testid="nav-blog" className="link-underline text-[#0f172a]/80 hover:text-[#084392]">
            Blog
          </Link>
          <Link to="/" data-testid="nav-home" className="link-underline text-[#0f172a]/80 hover:text-[#084392]">
            Home
          </Link>
        </nav>

        {!minimal && (
          <Link
            to="/#waitlist"
            data-testid="header-cta"
            className="inline-flex items-center h-10 px-5 rounded-md bg-[#084392] hover:bg-[#06326e] text-white text-sm font-semibold transition"
          >
            Join Waitlist
          </Link>
        )}
      </div>
    </header>
  );
}
